import { AnyAction } from 'redux';
import { Action, State } from './types';

export const DEFAULT_STATE: State = null;

// eslint-disable-next-line default-param-last
function reducer(state = DEFAULT_STATE, action: AnyAction): State {
  switch (action.type) {
    case Action.WORLDS_GET_SUCCESS: {
      const { worlds } = action.payload;
      return worlds;
    }
    default:
      return state;
  }
}

export default reducer;
